<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Button } from '@/components/ui/button'

const { t } = useI18n()

defineProps<{
    currentCount: number
    totalCount: number
}>()

const emit = defineEmits<{
    loadMore: []
}>()
</script>

<template>
    <div class="relative overflow-hidden">
        <nav class="flex flex-row items-center justify-between py-4" aria-label="Table navigation">
            <div class="text-sm">
                <p class="font-semibold text-foreground">
                    {{ currentCount }} <span class="font-normal text-muted-foreground">{{ t('common.of') }}</span>
                    {{ totalCount }}
                </p>
            </div>
            <Button
                v-if="currentCount < totalCount"
                size="sm"
                @click="emit('loadMore')"
            >
                Load more
            </Button>
        </nav>
    </div>
</template>
